import axios from 'axios';
import _ from 'lodash';
import { getHaulerMonthlyPayQuery } from './queries';
import moment from 'moment-timezone';

const getHaulerMonthlyPay = async (hauler_id, startDate, endDate) => {
    try {
        const haulerMonthlyPayQuery = getHaulerMonthlyPayQuery({
            hauler_id,
            startDate,
            endDate,
        });
        const haulerMonthlyPayResponse = await axios.get(haulerMonthlyPayQuery);
        const approvedHaulerPayReports = { settlementReports: [], advanceReports: [] };
        if (_.isEmpty(haulerMonthlyPayResponse?.data)) {
            return approvedHaulerPayReports;
        }
        haulerMonthlyPayResponse.data.forEach((report) => {
            if (report?.report_data?.approved_advance_report && (report?.report_data?.advance_report?.publish_date == null || moment(report?.report_data?.advance_report?.publish_date).isSameOrBefore(moment()))) {
                approvedHaulerPayReports.advanceReports.push(report);
            }
            if (report?.report_data?.approved_settlement_report && (report?.report_data?.settlement_report?.publish_date == null || moment(report?.report_data?.settlement_report?.publish_date).isSameOrBefore(moment()))) {
                approvedHaulerPayReports.settlementReports.push(report);
            }
        });
        return approvedHaulerPayReports;
    } catch (err) {
        throw new Error('Unable to process request.');
    }
};

export default getHaulerMonthlyPay;
